import * as actionTypes from '../actions/actionTypes';

export default function caseReducer(state = {}, action) {
  switch (action.type) {
    case actionTypes.CREATE_CASE: {
      const caseId = action.newCase.caseId;
      return Object.assign({}, state, { [caseId]: action.newCase });
    }
    case actionTypes.UPDATE_CASE: {
      let { caseId, productType, productData } = action;
      let cases = Object.assign({}, state);
      // removing existing product from cases
      for (var cId in cases) {
        if (cId !== caseId && cases[cId][productType][productData.id] !== undefined) {
          delete cases[cId][productType][productData.id];
        }
      }
      cases[caseId][productType][productData.id] = productData;
      return cases;
    }

    case actionTypes.UPDATE_CASE_ENTITY_NAME: {
      let { caseId, entityName } = action;
      let cases = Object.assign({}, state);
      // removing existing product from cases
      cases[caseId].entityName = entityName;
      return cases;
    }

    case actionTypes.DELETE_PRODUCT_FROM_CASE: {
      let { caseId, productType, productId } = action;
      let cases = Object.assign({}, state);
      delete cases[caseId][productType][productId];
      return cases;
    }
    case actionTypes.DELETE_CASE: {
      let { caseId } = action;
      let cases = Object.assign({}, state);
      delete cases[caseId];
      return cases;
    }
    case actionTypes.SET_CASES: {
      return action.cases.reduce((accumulator, _case, index) => {
        accumulator[_case.id] = action.entities && action.entities.length ? {
          ..._case,
          entityName: action.entities[index].entityName,
          entityId: action.entities[index].id,
          _caseId: _case.caseId,
          caseId: _case.id,
          accounts: {},
          echannels: {},
          glsproducts: {}
        } :
          {
            ..._case,
            _caseId: _case.caseId,
            caseId: _case.id,
            accounts: {},
            echannels: {},
            glsproducts: {}
          };
        return accumulator;
      }, {});
    }
    case actionTypes.UPDATE_CASE_STATUSES: {
      let cases = { ...state };
      action.caseStatuses.forEach(caseStatus => {
        if (cases[caseStatus && caseStatus.caseId]) {
          cases[caseStatus.caseId].status = caseStatus.statusKey;
          cases[caseStatus.caseId].statusValue = caseStatus.status;
        }
      });

      return cases;
    }
    default: {
      return state;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/createAcase/reducers/caseReducer.js